import { useCallback, useState } from "react";
import styled from "styled-components";

import { RecentSearch } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/RecentSearch/RecentSearch";
import { SearchInput } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchInput/SearchInput";
import { SearchResultMenu } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/SearchResultMenu";
import {
    SearchCategory,
    SearchResultItem,
} from "@/components/layout/Navbar/ApplicationSearch/application-search.types";
import { useSearchResults } from "@/components/layout/Navbar/ApplicationSearch/hooks/useSearchResults";
import { useShowResults } from "@/components/layout/Navbar/ApplicationSearch/hooks/useShowResults";
import { Popover } from "@/components/ui-deprecated/Popover";
import { useDebounce } from "@/hooks/useDebounce";
import { useAppDispatch, useAppSelector } from "@/store";
import { addRecentSearch } from "@/store/slices/recent-search.slice";

const SearchBarStyled = styled.div`
    position: relative;

    width: 100%;
`;

const PopoverStyled = styled(Popover)`
    max-height: 30rem;
    overflow-y: auto;
`;

type Props = {
    category: SearchCategory;
};

const SearchBar = (props: Props) => {
    const [query, setQuery] = useState("");

    const userId = useAppSelector((state) => state.user.id);
    const recentSearches = useAppSelector((state) => state.recentSearch.recentSearches);

    const queryDebounced = useDebounce(query, 250);
    const { data, isFetching } = useSearchResults(queryDebounced);

    const dispatch = useAppDispatch();

    // TODO Apply user roles
    // Show only search results relevant to the current user's role
    // const roleData = useApplyActiveRole(data);

    const { ref, showResults, handleOpen, handleClose } = useShowResults(query, recentSearches);

    const handleSearchBar = (item: SearchResultItem) => {
        dispatch(addRecentSearch({ userId, recentSearch: item }));
        setQuery("");
        handleClose();
    };

    const handleFocus = useCallback(() => {
        if (recentSearches.length === 0) {
            return;
        }
        handleOpen();
    }, [recentSearches, handleOpen]);

    return (
        <SearchBarStyled ref={ref}>
            <SearchInput value={query} setValue={setQuery} onFocus={handleFocus} />
            {showResults && (
                <PopoverStyled variant={"bottom"} $zIndex={100}>
                    <RecentSearch query={query} onClick={handleSearchBar} />
                    <SearchResultMenu
                        data={data}
                        query={query}
                        category={props.category}
                        isLoading={isFetching || query !== queryDebounced}
                        onClick={handleSearchBar}
                    />
                </PopoverStyled>
            )}
        </SearchBarStyled>
    );
};

export { SearchBar };
